export default [
  {
    icon: '',
    link: 'https://cloud.mail.ru/public/3myW/5uoPjVtwi',
    label: 'Контакты и график работы',
  },
  {
    icon: '',
    link: 'https://cloud.mail.ru/public/3myW/5uoPjVtwi',
    label: 'Тестовые пароли ТО/Способы оплаты',
  },
  {
    icon: '',
    link: 'https://cloud.mail.ru/public/3myW/5uoPjVtwi',
    label: 'Комиссия ТО',
  },
  {
    icon: '',
    link: 'https://cloud.mail.ru/public/V5Zb/2xn6HcDuc',
    label: 'Документы',
  },
];
